<template>
  <dragPanel
    title="纹理动画"
    :closePanel="closeTexturePanel"
    :tooltipVisible="true"
    class="common-drag-panel">
    <div
      v-if="isLoaded"
      class="texture-loaded-box">
      <div
        v-if="isEmpty()"
        class="empty-box">
        <div class="common-empty-box">
          <bj-empty
            :image="require('@/assets/img/no-data.png')"
            class="empty-page">
            <template slot="description">
              <div
                v-if="status === 'view'"
                class="public-tips-primary">
                当前还没有纹理动画
              </div>
              <div
                v-if="status === 'editPath'"
                class="public-tips-primary">
                已进入编辑状态，请点击模型开始添加
              </div>
              <div class="common-button-box">
                <el-button
                  class="primary-btn"
                  type="primary"
                  size="small"
                  :disabled="status === 'editPath'"
                  @click="addTexture">
                  添加
                </el-button>
                <el-button
                  class="primary-btn"
                  v-if="tipVisible"
                  size="small"
                  :disabled="status === 'editPath'"
                  @click="applyTexture">
                  应用
                </el-button>
              </div>
            </template>
          </bj-empty>
        </div>
        <div
          class="tip-box"
          v-if="tipVisible">
          <icon-svg
            icon-class="ic--s-tishi"
            class="icon" />
          <span class="public-tips-primary"
            >存在已删除未应用的记录，点击应用才可生效</span
          >
        </div>
      </div>
      <div
        v-else
        class="texture-box">
        <div class="common-button-box add-texture-box">
          <el-button
            class="primary-btn primary-ang-btn"
            type="primary"
            size="small"
            icon="el-icon-plus"
            :disabled="status === 'editPath'"
            @click="addTexture"
            >添加路径</el-button
          >
        </div>

        <div class="texture-list-box">
          <div class="texture-data-box">
            <div>
              <div
                class="common-tree-box"
                v-if="appliedData && appliedData[0].subNodes.length">
                <el-tree
                  class="dialog-tree-primary"
                  ref="appliedTree"
                  :data="appliedData"
                  :props="defaultProps"
                  :default-checked-keys="['all']"
                  node-key="nodeId"
                  highlight-current
                  show-checkbox
                  default-expand-all
                  :expand-on-click-node="false"
                  @node-click="handleNodeClick">
                  <div
                    slot-scope="{ data }"
                    class="custom-node-box">
                    <div
                      v-if="data.reNameFlag && isSelected(data)"
                      class="rename-box">
                      <div class="common-input-box">
                        <el-input
                          class="input-primary"
                          size="small"
                          :maxlength="20"
                          :value="data.nodeName"
                          @input="value => editPathName(data, value)"
                          autocomplete="off"
                          placeholder="请输入路径名称" />
                      </div>
                      <div class="action-button-box">
                        <i
                          class="el-icon-check submit-btn"
                          @click="savePathName(data)" />
                        <i
                          class="el-icon-close cancel-btn"
                          @click="cancelEditPathName(data)" />
                      </div>
                    </div>
                    <div
                      v-else
                      class="node-content-box">
                      <div class="node-label-box">
                        <el-tooltip
                        :effect="$theme.tooltipKey()"
                          v-if="!data.isPath"
                          placement="bottom-start"
                          popper-class="common-panel-tooltip-box"
                          content="注：已应用分组下的路径可直接查看效果">
                          <div
                            class="node-label text-overflow"
                            :title="data.nodeName">
                            {{ data.nodeName }}
                          </div>
                        </el-tooltip>
                        <div
                          v-else
                          class="node-label text-overflow"
                          :title="data.nodeName">
                          {{ data.nodeName }}
                        </div>
                        <div
                          v-show="data.isPath && status === 'view'"
                          class="icon-box">
                          <el-button
                            type="text"
                            size="small"
                            title="重命名"
                            @click="e => reNamePath(data, e)">
                            <icon-svg
                              icon-class="ic-bianjimingcheng1"
                              class="icon" />
                          </el-button>
                        </div>
                      </div>
                      <div
                        v-show="!data.isPath"
                        class="custom-button-box">
                        <el-button
                          type="text"
                          size="small"
                          :title="`批量${batchView ? '隐藏' : '显示'}`"
                          @click="batchToggleViewTexture"
                          :disabled="status === 'editPath'">
                          <icon-svg
                            v-if="batchView"
                            icon-class="ic-xianshi1"
                            class="icon" />
                          <icon-svg
                            v-else
                            icon-class="ic-a-yincang1"
                            class="icon" />
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          @click="batchStop"
                          :title="`批量${batchPaly ? '停止' : '播放'}`"
                          :disabled="status === 'editPath'">
                          <icon-svg
                            v-if="batchPaly"
                            icon-class="ic-bofang1"
                            class="icon" />
                          <icon-svg
                            v-else
                            icon-class="ic-zanting1"
                            class="icon" />
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          title="批量效果设置"
                          @click="e => openEffectDialog(data, e)"
                          :disabled="status === 'editPath'">
                          <icon-svg
                            icon-class="ic-xiaoguo"
                            class="icon" />
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          title="批量删除路径"
                          @click="e => batchDeletePaths(data, e)"
                          :disabled="status === 'editPath'">
                          <i class="el-icon-delete icon"></i>
                        </el-button>
                      </div>
                      <div
                        v-show="data.isPath"
                        class="custom-button-box">
                        <el-button
                          type="text"
                          size="small"
                          @click="e => toggleViewTexture(data, e)"
                          :title="`${data.isView ? '隐藏' : '显示'}`"
                          :disabled="status === 'editPath'">
                          <icon-svg
                            v-if="data.isView"
                            icon-class="ic-xianshi1"
                            class="icon" />
                          <icon-svg
                            v-else
                            icon-class="ic-a-yincang1"
                            class="icon" />
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          @click="e => stopUVAnim(data, e)"
                          :title="`${data.isPlay ? '停止' : '播放'}`"
                          :disabled="status === 'editPath'">
                          <icon-svg
                            v-if="data.isPlay"
                            icon-class="ic-bofang1"
                            class="icon" />
                          <icon-svg
                            v-else
                            icon-class="ic-zanting1"
                            class="icon" />
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          title="编辑路径"
                          @click="e => editTexture(data, e)"
                          :disabled="status === 'editPath'">
                          <icon-svg
                            icon-class="ic-bianjilujing1"
                            class="icon" />
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          title="效果设置"
                          @click="e => openEffectDialog(data, e)"
                          :disabled="status === 'editPath'">
                          <icon-svg
                            icon-class="ic-xiaoguo"
                            class="icon" />
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          title="删除路径"
                          @click="e => deletePath(data, e)"
                          :disabled="status === 'editPath'">
                          <i class="el-icon-delete icon"></i>
                        </el-button>
                      </div>
                    </div>
                  </div>
                </el-tree>
              </div>
              <div
                v-if="unAppliedData.length && unAppliedData[0].subNodes.length"
                class="common-tree-box bottom-tree-box">
                <el-tree
                  class="dialog-tree-primary"
                  ref="unAppliedTree"
                  :data="unAppliedData"
                  :props="defaultProps"
                  :default-checked-keys="['all']"
                  node-key="nodeId"
                  highlight-current
                  show-checkbox
                  default-expand-all
                  :expand-on-click-node="false"
                  @node-click="handleNodeClick">
                  <div
                    slot-scope="{ data }"
                    class="custom-node-box">
                    <div
                      v-if="data.reNameFlag && isSelected(data)"
                      class="rename-box">
                      <div class="common-input-box">
                        <el-input
                          class="input-primary"
                          size="small"
                          :value="data.nodeName"
                          @input="value => editPathName(data, value)"
                          autocomplete="off"
                          placeholder="请输入路径名称" />
                      </div>
                      <div class="action-button-box">
                        <i
                          class="el-icon-check submit-btn"
                          @click="savePathName(data)" />
                        <i
                          class="el-icon-close cancel-btn"
                          @click="cancelEditPathName(data)" />
                      </div>
                    </div>
                    <div
                      v-else
                      class="node-content-box">
                      <div class="node-label-box">
                        <el-tooltip
                        :effect="$theme.tooltipKey()"
                          v-if="!data.isPath"
                          placement="bottom-start"
                          popper-class="common-panel-tooltip-box"
                          content="注：未应用分组下的路径需要应用才可生效">
                          <div class="node-label">{{ data.nodeName }}</div>
                        </el-tooltip>
                        <div
                          v-else
                          class="node-label"
                          :title="data.nodeName">
                          {{ data.nodeName }}
                        </div>
                        <div
                          v-show="data.isPath && status === 'view'"
                          class="icon-box">
                          <el-button
                            type="text"
                            size="small"
                            title="重命名"
                            @click="e => reNamePath(data, e)">
                            <icon-svg
                              icon-class="ic-bianjimingcheng1"
                              class="icon" />
                          </el-button>
                        </div>
                      </div>
                      <div
                        v-show="!data.isPath"
                        class="custom-button-box">
                        <el-button
                          type="text"
                          size="small"
                          title="批量效果设置"
                          @click="e => openEffectDialog(data, e)"
                          :disabled="status === 'editPath'">
                          <icon-svg
                            icon-class="ic-xiaoguo"
                            class="icon" />
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          title="批量删除路径"
                          @click="e => batchDeletePaths(data, e)"
                          :disabled="status === 'editPath'">
                          <i class="el-icon-delete icon"></i>
                        </el-button>
                      </div>
                      <div
                        v-show="data.isPath"
                        class="custom-button-box">
                        <el-button
                          type="text"
                          size="small"
                          title="编辑路径"
                          @click="e => editTexture(data, e)"
                          :disabled="status === 'editPath'">
                          <icon-svg
                            icon-class="ic-bianjilujing1"
                            class="icon" />
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          title="效果设置"
                          @click="e => openEffectDialog(data, e)"
                          :disabled="status === 'editPath'">
                          <icon-svg
                            icon-class="ic-xiaoguo"
                            class="icon" />
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          title="删除路径"
                          @click="e => deletePath(data, e)"
                          :disabled="status === 'editPath'">
                          <i class="el-icon-delete icon"></i>
                        </el-button>
                      </div>
                    </div>
                  </div>
                </el-tree>
              </div>
            </div>
            <div
              class="tip-box"
              v-if="tipVisible">
              <icon-svg
                icon-class="ic--s-tishi"
                class="icon" />
              <span class="public-tips-primary"
                >存在已删除未应用的记录，点击应用才可生效</span
              >
            </div>
          </div>
          <div
            class="common-button-box bottom-button-box"
            v-if="unAppliedData.length">
            <el-button
              class="primary-btn primary-ang-btn"
              size="small"
              type="primary"
              @click="applyTexture"
              :disabled="status === 'editPath'">
              应用
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <TextureLoading
      v-if="loading"
      :upgradeFlag="upgradeFlag"
      :status="applyStatus"
      :progress="progress" />
  </dragPanel>
</template>

<script>
import dragPanel from '@/components/CustomDragPanel.vue'
import TextureLoading from './TextureLoading.vue'

import Texture from '../script/Texture'

import {
  getTextureList,
  updateTextureName,
  createTextureService,
  updateTextureSrevice,
  textureEffectSrevice,
  deleteTextureSrevice,
  isUpgradeService,
  applyTextureService,
  applyTextureQueueService,
  getTextureProgressService,
  getTextureStatusService
} from '@/service/interface'

export default {
  data() {
    return {
      status: 'view',
      batchView: true,
      batchPaly: true,
      isLoaded: false,
      appliedData: [
        {
          nodeId: 'all',
          nodeName: '已应用',
          isApplied: true,
          isPath: false,
          subNodes: []
        }
      ],
      unAppliedData: [
        {
          nodeId: 'all',
          nodeName: '未应用',
          isApplied: false,
          isPath: false,
          subNodes: []
        }
      ],
      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      },
      selectedPath: {},
      selectedPaths: [],
      loading: false,
      applyStatus: 0,
      progress: 0,

      tipVisible: false,

      upgradeFlag: false,

      textureList: []
    }
  },
  props: {
    modelInfo: Array,
    closePanel: Function,
    openConfigDialog: Function,
    reloadMainScene: Function,
    openCountDown: Function
  },
  components: {
    dragPanel,
    TextureLoading
  },
  mounted() {
    this.initTextureData()
    this.initTextureSequence()
  },
  beforeDestroy() {
    if (this.timer) {
      this.loading = false
      clearInterval(this.timer)
      this.timer = null
    }

    this.clearDomEvent()
  },
  methods: {
    initTextureSequence() {
      let dataSetId = this.$route.query.datasetId
      this.isNeedUpgrade().then(() => {
        getTextureStatusService({ dataSetId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (data.status === 1 || data.status === 2) {
              this.loading = true
              this.timer = setInterval(this.queryApplyProgress, 5000)
            }
          }
        })
      })
    },
    isNeedUpgrade() {
      return new Promise(resolve => {
        let dataSetId = this.$route.query.datasetId
        isUpgradeService({ dataSetIds: [dataSetId] }).then(response => {
          let data = response.data[0]
          if (data && data.needUpgrade) {
            this.upgradeFlag = true
          } else {
            this.upgradeFlag = false
          }
          resolve()
        })
      })
    },
    initTextureData() {
      this.queryTextureList().then(data => {
        let { appliedData, unAppliedData } = data
        appliedData = this.formatData(appliedData)
        unAppliedData = this.formatData(unAppliedData)
        this.appliedData[0].subNodes = appliedData
        this.unAppliedData[0].subNodes = unAppliedData

        this.isLoaded = true
      })
    },
    addTexture() {
      let dataSetId = this.$route.query.datasetId
      isUpgradeService({ dataSetIds: [dataSetId] }).then(response => {
        let data = response.data[0]
        let appliedData = this.appliedData[0].subNodes
        let unAppliedData = this.unAppliedData[0].subNodes
        let pathExist = Boolean(appliedData.length || unAppliedData.length)
        if (data && data.needUpgrade && data.versionNum > 1 && !pathExist) {
          let message =
            '为保证更好的用户体验，系统进行了重大升级。本次添加纹理将会合并当前模型的全部历史版本，是否继续？'
          this.$confirm(message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.$message.info('您已进入编辑模式，请选择构件开始编辑')
              this.status = 'editPath'
              let dataSetId = this.$route.query.datasetId
              let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
              let resId = find.resId
              let texture = new Texture(
                resId,
                this.createPath,
                this.mouseMove,
                this.onPathProgress
              )
              texture.createTexture()

              let textureExist = this.textureList.find(
                el => el.pipeId === texture.pipeId
              )
              if (!textureExist) {
                this.textureList.push(texture)
              }
            })
            .catch(() => {
              this.$message.info('取消添加')
            })
        } else {
          this.$message.info('您已进入编辑模式，请选择构件开始编辑')
          this.status = 'editPath'
          let dataSetId = this.$route.query.datasetId
          let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
          let resId = find.resId
          let texture = new Texture(
            resId,
            this.createPath,
            this.mouseMove,
            this.onPathProgress
          )
          texture.createTexture()

          let textureExist = this.textureList.find(
            el => el.pipeId === texture.pipeId
          )
          if (!textureExist) {
            this.textureList.push(texture)
          }
        }
      })
    },
    editTexture(nodeData, e) {
      e.stopPropagation()
      this.hiddenTexture(nodeData)

      this.status = 'editPath'
      let dataSetId = this.$route.query.datasetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId
      let texture = new Texture(
        resId,
        this.updatePath,
        this.mouseMove,
        this.onPathProgress
      )
      texture.editTexture(nodeData)

      let textureExist = this.textureList.find(
        el => el.pipeId === texture.pipeId
      )
      if (!textureExist) {
        this.textureList.push(texture)
      }

      this.selectedPath = nodeData
    },
    hiddenTexture(nodeData) {
      let BlackHole3D = window.BlackHole3D
      let dataSetId = this.$route.query.datasetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId

      let anim = new BlackHole3D.REElemUVAnim()
      anim.dataSetId = resId
      anim.elemIdList = nodeData.elements
      anim.scale = [0, 0]
      anim.speed = [0.0, 0.0]
      BlackHole3D.BIM.setElemUVAnimAttr(anim)

      nodeData.isView = false
    },
    toggleViewTexture(nodeData, e) {
      e && e.stopPropagation()
      let BlackHole3D = window.BlackHole3D
      let dataSetId = this.$route.query.datasetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId

      let anim = new BlackHole3D.REElemUVAnim()
      anim.dataSetId = resId
      anim.elemIdList = nodeData.elements
      if (nodeData.isView) {
        anim.scale = [0, 0]
        anim.speed = [0.0, 0.0]
      } else {
        let scale = Number((1 / nodeData.compressionRatio).toFixed(2))
        anim.scale = [scale, 1]
        if (nodeData.isPlay) {
          let speed =
            nodeData.direction > 0 ? nodeData.flowRate : -nodeData.flowRate
          anim.speed = [speed, 0]
        }
      }
      BlackHole3D.BIM.setElemUVAnimAttr(anim)

      nodeData.isView = !nodeData.isView
    },
    batchToggleViewTexture() {
      let checkData = this.$refs.appliedTree
        ? this.$refs.appliedTree.getCheckedNodes(true)
        : []
      this.selectedPaths = checkData

      if (!this.selectedPaths.length) {
        this.$message.warning('请先选择需要批量操作的数据')
        return
      }

      let BlackHole3D = window.BlackHole3D
      let dataSetId = this.$route.query.datasetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId

      this.selectedPaths.forEach(item => {
        let anim = new BlackHole3D.REElemUVAnim()
        anim.dataSetId = resId
        anim.elemIdList = item.elements
        anim.scale = [item.compressionRatio, 1]

        if (this.batchView) {
          anim.scale = [0, 0]
          anim.speed = [0.0, 0.0]
        } else {
          let scale = Number((1 / item.compressionRatio).toFixed(2))
          anim.scale = [scale, 1]
          if (item.isPlay) {
            let speed = item.direction > 0 ? item.flowRate : -item.flowRate
            anim.speed = [speed, 0]
          }
        }
        BlackHole3D.BIM.setElemUVAnimAttr(anim)

        item.isView = !this.batchView
      })

      this.batchView = !this.batchView
    },
    batchStop() {
      let checkData = this.$refs.appliedTree
        ? this.$refs.appliedTree.getCheckedNodes(true)
        : []
      this.selectedPaths = checkData

      if (!this.selectedPaths.length) {
        this.$message.warning('请先选择需要批量操作的数据')
        return
      }

      let BlackHole3D = window.BlackHole3D
      let dataSetId = this.$route.query.datasetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId

      this.selectedPaths.forEach(item => {
        let anim = new BlackHole3D.REElemUVAnim()
        anim.dataSetId = resId
        anim.elemIdList = item.elements
        let scale = Number((1 / item.compressionRatio).toFixed(2))
        anim.scale = [scale, 1]

        if (this.batchPaly) {
          anim.speed = [0.0, 0.0]
        } else {
          let speed = item.direction > 0 ? item.flowRate : -item.flowRate
          anim.speed = [speed, 0]
        }

        BlackHole3D.BIM.setElemUVAnimAttr(anim)

        item.isPlay = !this.batchPaly
      })

      this.batchPaly = !this.batchPaly
    },
    stopUVAnim(nodeData, e) {
      e.stopPropagation()
      let BlackHole3D = window.BlackHole3D
      let dataSetId = this.$route.query.datasetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId

      let anim = new BlackHole3D.REElemUVAnim()
      anim.dataSetId = resId
      anim.elemIdList = nodeData.elements
      let scale = Number((1 / nodeData.compressionRatio).toFixed(2))
      anim.scale = [scale, 1]
      if (nodeData.isPlay) {
        anim.speed = [0.0, 0.0]
      } else {
        let speed =
          nodeData.direction > 0 ? nodeData.flowRate : -nodeData.flowRate
        anim.speed = [speed, 0]
      }

      nodeData.isPlay = !nodeData.isPlay

      BlackHole3D.BIM.setElemUVAnimAttr(anim)
    },
    openEffectDialog(nodeData, e) {
      e && e.stopPropagation()
      if (!nodeData.isPath) {
        if (nodeData.isApplied) {
          let paths = this.$refs.appliedTree
            ? this.$refs.appliedTree.getCheckedNodes(true)
            : []
          this.selectedPaths = paths
        } else {
          let paths = this.$refs.unAppliedTree
            ? this.$refs.unAppliedTree.getCheckedNodes(true)
            : []
          this.selectedPaths = paths
        }
      } else {
        this.selectedPaths = [nodeData]
      }

      if (!this.selectedPaths.length) {
        this.$message.warning('请先选择需要批量操作的数据')
        return
      }

      this.openConfigDialog(nodeData)
    },
    setEffect(configInfo) {
      let textureIds = this.selectedPaths.map(el => el.id)
      return new Promise(resolve => {
        let params = {
          textureIds: textureIds,
          direction: configInfo.direction ? 1 : 0,
          flowRate: configInfo.flowRate,
          compressionRatio: configInfo.compressionRatio,
          imageSrc: configInfo.imageSrc
        }
        textureEffectSrevice(params).then(response => {
          if (response.isSuccess) {
            this.updateTextureData().then(() => {
              let BlackHole3D = window.BlackHole3D
              let dataSetId = this.$route.query.datasetId
              let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
              let resId = find.resId
              this.selectedPaths.forEach(item => {
                let anim = new BlackHole3D.REElemUVAnim()
                anim.dataSetId = resId
                anim.elemIdList = item.elements

                if (item.isView && item.isApplied) {
                  let scale = Number(
                    (1 / configInfo.compressionRatio).toFixed(2)
                  )
                  anim.scale = [scale, 1]
                  let speed =
                    configInfo.direction > 0
                      ? configInfo.flowRate
                      : -configInfo.flowRate
                  anim.speed = [speed, 0]
                } else {
                  anim.scale = [0, 0]
                  anim.speed = [0.0, 0.0]
                }

                BlackHole3D.BIM.setElemUVAnimAttr(anim)
              })

              this.$message.success('设置效果成功')
              this.$nextTick(() => {
                this.setCheckedKeys()
              })
              resolve(response)
            })
          } else {
            resolve(response)
          }
        })
      })
    },
    cancelEffectSet() {
      this.selectedPaths = []
    },
    reNamePath(nodeData, e) {
      e && e.stopPropagation()
      if (this.selectedPath.reNameFlag) {
        let nodeName = this.selectedPath.nodeName
        let message = `${nodeName}正在编辑，请编辑完成后再选择其它路径。`
        this.$message.warning(message)
        return
      }
      this.$set(nodeData, 'reNameFlag', true)
      this.selectedPath = nodeData
    },
    editPathName(nodeData, value) {
      this.$set(nodeData, 'nodeName', value)
    },
    savePathName(nodeData) {
      let value = nodeData.nodeName
      if (value.length !== value.trimStart().trimEnd().length) {
        this.$message.warning('开头和结尾不允许有空格')
        return
      }

      let params = {
        name: nodeData.nodeName,
        textureId: nodeData.id
      }
      updateTextureName(params).then(response => {
        if (response.isSuccess) {
          this.updateTextureData().then(() => {
            this.$set(nodeData, 'reNameFlag', false)
            this.$nextTick(() => {
              this.setCheckedKeys()
            })
          })
        }
      })
    },
    cancelEditPathName(nodeData) {
      this.queryTextureList().then(data => {
        let { appliedData, unAppliedData } = data
        let textureData = [...appliedData, ...unAppliedData]
        let find = textureData.find(el => el.id === nodeData.id)
        nodeData.nodeName = find.name
        this.$set(nodeData, 'reNameFlag', false)
      })
    },
    applyTexture() {
      let unAppliedData = this.$refs.unAppliedTree
        ? this.$refs.unAppliedTree.getCheckedNodes(true)
        : []
      let textureIds = unAppliedData.map(el => el.id)

      if (!this.tipVisible && !textureIds.length) {
        this.$message.warning('当前勾选的路径均已生效，无需再次应用')
        return
      }

      this.loading = true
      let dataSetId = this.$route.query.datasetId
      this.isUpgrade(textureIds).then(result => {
        if (result) {
          let params = { dataSetId, textureIds }
          applyTextureService(params).then(response => {
            if (response.isSuccess) {
              this.queryApplyProgress()
              this.timer = setInterval(this.queryApplyProgress, 5000)
            } else {
              this.$message.error(response.errMsg)
              this.loading = false
            }
          })
        }
      })
    },
    isUpgrade(textureIds) {
      return new Promise(resolve => {
        let dataSetId = this.$route.query.datasetId
        isUpgradeService({ dataSetIds: [dataSetId] }).then(response => {
          let data = response.data[0]
          if (data && data.needUpgrade) {
            this.upgradeFlag = true
            let params = { dataSetId, textureIds }
            applyTextureQueueService(params).then(res => {
              if (res.isSuccess) {
                this.timer = setInterval(this.queryApplyProgress, 5000)
                resolve(false)
              } else {
                this.$message.error(res.errMsg)
                this.loading = false
                resolve(false)
              }
            })
          } else {
            this.upgradeFlag = false
            resolve(true)
          }
        })
      })
    },
    queryApplyProgress() {
      let dataSetId = this.$route.query.datasetId
      getTextureStatusService({ dataSetId }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let status = data.status
          this.applyStatus = status
          if (status === 2) {
            let params = { dataSetIds: [dataSetId] }
            getTextureProgressService(params).then(res => {
              if (res.isSuccess) {
                let result = res.data
                let data = result[0]
                let ratio = Math.round(data.ratio / 100) / 100
                if (ratio === 100) {
                  this.progress = ratio
                  clearInterval(this.timer)
                  this.timer = null

                  this.updateTextureData()

                  this.openCountDown()
                } else {
                  this.progress = ratio
                }
              }
            })
          } else if (status === 10) {
            this.progress = 100
            clearInterval(this.timer)
            this.timer = null

            this.updateTextureData()

            this.openCountDown()
          } else if (status === 20) {
            this.$message.error('应用失败')
            this.loading = false
            clearInterval(this.timer)
            this.timer = null
          }
        }
      })
    },
    handleNodeClick(nodeData) {
      if (this.isSelected(nodeData)) return

      if (this.selectedPath.reNameFlag) {
        let nodeName = this.selectedPath.nodeName
        let message = `${nodeName}正在编辑，请编辑完成后再选择其它路径。`
        this.$message.warning(message)
        return
      }
      this.selectedPath = nodeData

      let dataSetId = nodeData.dataSetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      if (find) {
        let Camera = window.BlackHole3D.Camera
        let resId = find.resId
        Camera.setCamLocateToElem(
          [
            {
              dataSetId: resId,
              elemIdList: nodeData.elements
            }
          ],
          1.0
        )
      }
    },
    createPath(pipeInfo) {
      if (!pipeInfo.elements.length) {
        this.status = 'view'
        this.$message.warning('构件不能为空')
        return
      }
      let dataSetId = this.$route.query.datasetId
      let params = {
        dataSetId: dataSetId,
        points: pipeInfo.points,
        elements: pipeInfo.elements
      }
      createTextureService(params).then(response => {
        if (response.isSuccess) {
          this.updateTextureData().then(() => {
            this.status = 'view'

            const h = this.$createElement
            this.$message({
              showClose: false,
              type: 'success',
              message: h('span', { style: { color: '#6fc13f',display:'flex' } }, [
                '点击【',
                h('icon-svg', { attrs: { 'icon-class': 'ic-xiaoguo' } }, null),
                '】可设置贴图效果，点击应用即可生效'
              ]),
              duration: 5000
            })

            this.$nextTick(() => {
              this.setCheckedKeys()
            })
          })
        }
      })
    },
    updatePath(pipeInfo) {
      if (!pipeInfo.elements.length) {
        this.status = 'view'
        this.$message.warning('构件不能为空')
        return
      }

      let originElements = this.selectedPath.elements
      let newElements = pipeInfo.elements.map(el => Number(el.elementIntId))
      if (this.isSameArray(originElements, newElements)) {
        this.toggleViewTexture(this.selectedPath)
        this.status = 'view'
        this.$message.warning('尚未对路径做出任何修改')
        return
      }

      let params = {
        textureId: pipeInfo.pipeId,
        points: pipeInfo.points,
        elements: pipeInfo.elements
      }
      updateTextureSrevice(params).then(response => {
        if (response.isSuccess) {
          this.updateTextureData().then(() => {
            this.status = 'view'

            this.$nextTick(() => {
              this.setCheckedKeys()
            })
          })
        }
      })
    },
    mouseMove(eventInfo) {
      let { clientX, clientY } = eventInfo
      let obj = { clientX, clientY }
      this.$eventManage.fire('mouseMove', obj)
    },
    onPathProgress(eventInfo) {
      this.$eventManage.fire('pathProgress', eventInfo)
    },

    deletePath(nodeData, e) {
      e.stopPropagation()
      let message = '删除后，路径信息无法恢复，确定要删除吗?'
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.hiddenTexture(nodeData)
          let params = {
            textureIds: [nodeData.id]
          }
          deleteTextureSrevice(params).then(response => {
            if (response.isSuccess) {
              this.updateTextureData().then(() => {
                this.$message.success('删除成功！')

                this.$nextTick(() => {
                  this.setCheckedKeys()
                })
              })
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    batchDeletePaths(nodeData, e) {
      e && e.stopPropagation()
      let paths = []
      if (nodeData.isApplied) {
        paths = this.$refs.appliedTree
          ? this.$refs.appliedTree.getCheckedNodes(true)
          : []
      } else {
        paths = this.$refs.unAppliedTree
          ? this.$refs.unAppliedTree.getCheckedNodes(true)
          : []
      }

      if (!paths.length) {
        this.$message.warning('请先选择需要批量删除的数据')
        return
      }

      let message = '删除后，路径信息无法恢复，确定要删除吗?'
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          paths.forEach(item => {
            this.hiddenTexture(item)
          })
          let textureIds = paths.map(el => el.id)
          deleteTextureSrevice({ textureIds }).then(response => {
            if (response.isSuccess) {
              this.updateTextureData().then(() => {
                this.$message.success('删除成功！')

                this.$nextTick(() => {
                  this.setCheckedKeys()
                })
              })
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    updateTextureData() {
      return new Promise(resolve => {
        this.queryTextureList().then(data => {
          let { appliedData, unAppliedData } = data
          appliedData = this.formatData(appliedData)
          unAppliedData = this.formatData(unAppliedData)
          this.appliedData[0].subNodes = appliedData
          this.unAppliedData[0].subNodes = unAppliedData
          resolve()
        })
      })
    },
    closeTexturePanel() {
      let BlackHole3D = window.BlackHole3D
      let textureStatus = BlackHole3D.Pipe.getContPipeMode()
      if (textureStatus) {
        let message = '当前正处于纹理编辑状态，请先结束纹理编辑'
        this.$message.warning(message)
        return
      }
      this.closePanel()
    },
    queryTextureList() {
      return new Promise(resolve => {
        let dataSetId = this.$route.query.datasetId
        getTextureList({ dataSetId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let appliedData = data.filter(
              el => el.isApplied && !el.removeStatus
            )
            let unAppliedData = data.filter(
              el => !el.isApplied && !el.removeStatus
            )

            let tipVisible = false
            tipVisible = data.some(el => el.removeStatus)
            this.tipVisible = tipVisible

            resolve({ appliedData, unAppliedData })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    setCheckedKeys() {
      if (this.$refs.appliedTree) {
        this.$refs.appliedTree.setCheckedKeys(['all'])
      }
      if (this.$refs.unAppliedTree) {
        this.$refs.unAppliedTree.setCheckedKeys(['all'])
      }
    },
    isSelected(nodeData) {
      return this.selectedPath.id === nodeData.id
    },
    isEmpty() {
      let isEmpty = false
      let appliedData = this.appliedData[0].subNodes
      let unAppliedData = this.unAppliedData[0].subNodes
      if (!appliedData.length && !unAppliedData.length) {
        isEmpty = true
      }
      return isEmpty
    },
    isSameArray(originArray, newArray) {
      if (originArray.length !== newArray.length) return false

      let flag = true
      for (let i = 0; i < originArray.length; i++) {
        let originElemId = originArray[i]
        let newElemId = originArray[i]
        if (originElemId !== newElemId) {
          flag = false
          break
        }
      }
      return flag
    },
    formatData(data) {
      data.forEach(item => {
        item.nodeName = item.name
        item.subNodes = []
        item.isPath = true
        item.isPlay = true
        item.isView = true
      })
      return data
    },
    getWarningMessage(pathNameList, messageTail) {
      let message = ''
      let messageHead = ''
      // 超过两个文件只展示前两个
      if (pathNameList.length > 2) {
        messageHead = `${pathNameList[0]}、${pathNameList[1]}等${pathNameList.length}个`
      } else {
        messageHead = pathNameList.join('、')
      }
      message = `${messageHead}${messageTail}`
      return message
    },
    clearDomEvent() {
      this.textureList.forEach(texture => {
        texture.removeEventListener()
      })

      this.textureList = []
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  right: 20px;
  top: 150px;
  width: 360px;
  height: calc(100% - 225px);
  min-width: 360px;
  min-height: 300px;

  /deep/ .content {
    position: relative;
    height: calc(100% - 39px);

    .tip-box {
      font-size: 14px;
      color: var(--page-tips-text-color);
      text-align: left;
      display: flex;
      align-items: center;

      .icon {
        margin-right: 5px;
      }
    }

    .texture-loaded-box {
      height: 100%;
    }

    .empty-box {
      height: 100%;
      .common-empty-box {
        height: calc(100% - 32px);

        .common-button-box {
          margin-top: 20px;

          .el-button {
            padding: 10px 40px;
          }
        }
      }

      .tip-box {
        margin-left: 15px;
      }
    }

    .texture-box {
      height: 100%;

      .add-texture-box {
        padding: 16px;
        text-align: left;
        border-bottom: 1px solid var(--dialog-split-line-color);

        .el-button {
          width: 100%;
          margin-right: 0px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .texture-list-box {
        display: flex;
        flex-direction: column;
        height: calc(100% - 65px);

        .texture-data-box {
          flex-grow: 1;
          padding: 10px;
          overflow: auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .common-tree-box {
            // .el-tree {
            //   background: transparent;

            //   .el-tree-node__children > .el-tree-node {
            //     .el-tree-node__content {
            //       // padding-left: 48px !important;

            //       .is-leaf{
            //         margin-left: 6px;
            //       }
            //     }
            //   }
            // }
            .rename-box {
              display: flex;
              width: 100%;

              .common-input-box {
                flex-grow: 1;

                .el-input__inner{
                  height: 24px;
                }
              }

              .action-button-box {
                margin: 0px 10px;
                line-height: 26px;

                .submit-btn {
                  color: var(--base-light-color3);
                }

                .cancel-btn {
                  margin-left: 10px;
                  color: var(--base-light-color4);
                }
              }
            }
            .custom-node-box {
              width: calc(100% - 45px);
              height: 26px;

              .node-content-box {
                display: flex;
                justify-content: space-between;
                height: 100%;

                .node-label-box {
                  display: flex;
                  align-items: center;
                  flex-grow: 1;
                  overflow: hidden;
                height: 100%;
                  display: flex;
                  align-items: center;

                  .node-label {
                    font-size: 14px;
                    font-weight: 400;
                height: 100%;
                    display: flex;
                    align-items: center;
                  }

                  .icon-box {
                    display: none;
                    margin-left: 5px;

                    .icon {
                      font-size: 14px;
                      color: var(--default-color);
                    }

                    .el-button--text {
                      padding: 0px;
                    }
                  }

                  &:hover {
                    .icon-box {
                      display: block;
                    }
                  }
                }

                .custom-button-box {
                  margin: 0px 5px;
                height: 100%;
                display: flex;
                align-items: center;

                  .el-button {
                    margin-right: 0px;
                    padding: 0px;
                  }
                  

                  .icon {
                    font-size: 14px;
                  }
                }
              }
            }
          }

          .bottom-tree-box {
            min-height: 50%;
          }
        }

        .bottom-button-box {
          border-top: 1px solid var(--dialog-footer-border-color);
          padding: 16px;
          text-align: right;
        }
      }
    }
  }
}
</style>
